<!-- 答题界面 -->
<template>
<div class="m-exam">
    <div class="nav">
        <van-icon name="arrow-left" @click="handleReturnDetails" />
        <div class="nav-name">{{ navname }}</div>
    </div>
    <div class="exam-content">
        <div class="examname-count">
            <div class="examname">{{ examinfo.examname }}</div>
            <div class="count" v-if="answerSheetData.allcount"><span>{{ page }}</span>/{{ answerSheetData.allcount }}</div>
        </div>
        <el-scrollbar class="answer-area-scroll">
            <AnswerArea v-if="questioninfo.length" ref="answerArea" :submitAutoJump="submitAutoJump" :examinfo="examinfo" :questioninfo="$route.params.examsource == 6 ? [questioninfo[page - 1]] : questioninfo" :pattern="pattern" :fontSize="fontSize" @handleSaveExamQuestionSuccess="handleSaveExamQuestionSuccess" @handleNextPage="handleNextPage"></AnswerArea>
            <div class="empty-box" v-else>
                <img class="icon" :src="require('@/common/images/specialTopic/empty_icon.png')" />
                <div class="text">暂无数据</div>
            </div>
        </el-scrollbar>
        <div class="bottom-handle">
            <div class="handle-page" :class="{disabled: page === 1}" @click="handleChangePage('previous')">
                <i class="el-icon-caret-left icon"></i>
            </div>
            <div class="handle-item" v-if="examinfo.examstatus === 0 && examinfo.isastrict && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)">
                <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/clock_icon.png')" />
                <div class="label">{{ examTime }}</div>
            </div>
            <div class="handle-item" @click="answerSheetShow = true">
                <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/answer_sheet_icon.png')" />
                <div class="label">答题卡</div>
            </div>
            <div class="handle-item" @click="handleSaveTopicUserExamQuestionError(questioninfo[0])" v-if="$route.params.examsource == 5">
                <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/answer_sheet_icon.png')" />
                <div class="label">移除错题</div>
            </div>
            <div class="handle-item" v-if="questioninfo.length && ($route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)" @click="handleSaveTopicUserExamQuestionFavorite(questioninfo[0])">
                <i class="el-icon-star-on" v-if="questioninfo[0].isfavorite"></i>
                <i class="el-icon-star-off" v-if="!questioninfo[0].isfavorite"></i>
                <div class="label">{{ questioninfo[0].isfavorite ? '取消收藏' : '收藏题目' }}</div>
            </div>
            <div class="handle-item" v-if="questioninfo.length && $route.params.examsource == 6" @click="handleSaveTopicUserExamQuestionFavorite(questioninfo[page - 1])">
                <i class="el-icon-star-on" v-if="questioninfo[page - 1].isfavorite"></i>
                <i class="el-icon-star-off" v-if="!questioninfo[page - 1].isfavorite"></i>
                <div class="label">{{ questioninfo[page - 1].isfavorite ? '取消收藏' : '收藏题目' }}</div>
            </div>
            <div class="handle-item" @click="answerSetShow = true">
                <i class="el-icon-setting"></i>
                <div class="label">答题设置</div>
            </div>
            <div class="handle-page" :class="{disabled: page >=  pageinfo.rowCount}" @click="handleChangePage('next')">
                <i class="el-icon-caret-right icon"></i>
            </div>
        </div>
    </div>
    <van-popup v-model="answerSheetShow" position="bottom" class="answer-sheet-popup">
        <div class="title">答题卡</div>
        <div class="legend-box">
            <div class="pattern" v-if="pattern === 1">
                <div class="item">
                    <div class="label">已做</div>
                    <div class="square"></div>
                </div>
                <div class="item">
                    <div class="label">未做</div>
                    <div class="square not-done"></div>
                </div>
            </div>
            <div class="pattern" v-if="pattern === 2">
                <div class="item">
                    <div class="label">正确</div>
                    <div class="square correct"></div>
                </div>
                <div class="item">
                    <div class="label">错误</div>
                    <div class="square error"></div>
                </div>
                <div class="item">
                    <div class="label">未做</div>
                    <div class="square not-done"></div>
                </div>
            </div>
        </div>
        <el-scrollbar class="question-scroll" :style="{height: examinfo.examstatus === 0 && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4) ? 'calc(100% - 0.89rem - 0.62rem - 1rem)' : 'calc(100% - 0.89rem - 0.62rem)'}">
            <div class="question-item-box">
                <div class="question-item" @click="handleJumpPage(item)" v-for="(item) in answerSheetData.answerkeysinfo" :class="{issubmit: item.issubmit && examinfo.examstatus === 0 && pattern === 1, correct: item.issubmit && item.answerstatus === 1 && (examinfo.examstatus === 1 || pattern === 2), error: item.issubmit && item.answerstatus === 0 && (examinfo.examstatus === 1 || pattern === 2)}" :key="item.innerid">
                    {{ item.questionindex }}
                </div>
            </div>
        </el-scrollbar>
        <div class="btn-box" v-if="examinfo.examstatus === 0 && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)">
            <div class="submit-exam" @click="handleSubmitExam">提交试卷</div>
            <div class="save-progress" @click="handleSaveProgress">保存进度，下次继续</div>
        </div>
    </van-popup>
    <van-popup v-model="answerSetShow" position="bottom" class="answer-set-popup">
        <div class="font-size-set handle-item">
            <div class="icon-label" style="align-items: center;">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/font_size_icon.png')" />
                <div class="label">字体大小</div>
            </div>
            <div class="handle-box">
                <div class="item" :class="{active: fontSize === 28}" @click="handleChangeFontSize(28)">小</div>
                <div class="item" :class="{active: fontSize === 32}" @click="handleChangeFontSize(32)">中</div>
                <div class="item" :class="{active: fontSize === 36}" @click="handleChangeFontSize(36)">大</div>
                <div class="item" :class="{active: fontSize === 40}" @click="handleChangeFontSize(40)">超大</div>
            </div>
        </div>
        <div class="handle-item" v-if="examinfo.examstatus === 0 && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)">
            <div class="icon-label">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/jump_icon.png')" />
                <div class="label-tips">
                    <div class="label">自动跳转</div>
                    <div class="tips">做完1题，自动跳转下一题</div>
                </div>
            </div>
            <div class="handle-box">
                <el-switch v-model="submitAutoJump" active-color="#409EFF" @change="handleSubmitAutoJumpChange"></el-switch>
            </div>
        </div>
        <div class="handle-item" v-if="examinfo.examstatus === 0 && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)">
            <div class="icon-label">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/pattern1_icon.png')" />
                <div class="label-tips">
                    <div class="label">做题模式</div>
                    <div class="tips">提交后显示答案和解析</div>
                </div>
            </div>
            <div class="handle-box" @click="handleChangePattern(1)">
                <el-radio v-model="pattern" :label="1"></el-radio>
            </div>
        </div>
        <div class="handle-item" v-if="examinfo.examstatus === 0 && ($route.params.examsource == 1 || $route.params.examsource == 2 || $route.params.examsource == 3 || $route.params.examsource == 4)">
            <div class="icon-label">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/pattern2_icon.png')" />
                <div class="label-tips">
                    <div class="label">背题模式</div>
                    <div class="tips">答题后显示答案和解析</div>
                </div>
            </div>
            <div class="handle-box" @click="handleChangePattern(2)">
                <el-radio v-model="pattern" :label="2"></el-radio>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="saveProgressSuccessShow" class="save-progress-success-popup">
        <img :src="require('@/common/images/mSpecialTopic/save_progress_success_bg1.png')" class="bg1" />
        <img :src="require('@/common/images/mSpecialTopic/save_progress_success_bg2.png')" class="bg2" />
        <i class="el-icon-close" @click="handleExit"></i>
        <img :src="require('@/common/images/mSpecialTopic/save_progress_success.png')" class="success-icon" />
        <div class="text">进度保存成功，下次进来将保留你的答题记录</div>
        <div class="btn" @click="handleExit">好的</div>
    </van-popup>
    <van-popup v-model="exitTipsShow" class="exit-tips-popup">
        <img :src="require('@/common/images/mSpecialTopic/save_progress_success_bg1.png')" class="bg1" />
        <img :src="require('@/common/images/mSpecialTopic/save_progress_success_bg2.png')" class="bg2" />
        <i class="el-icon-close" @click="exitTipsShow = false"></i>
        <img :src="require('@/common/images/mSpecialTopic/exit_icon.png')" class="exit-icon" />
        <div class="text" style="margin-bottom: 0;">当前正在答题</div>
        <div class="text">继续退出将为您保留做题记录</div>
        <div class="btn-box">
            <div class="btn-item cancel" @click="exitTipsShow = false">取消</div>
            <div class="btn-item exit" @click="handleSaveExit">退出</div>
        </div>
    </van-popup>
    <van-popup v-model="examResultShow" class="exam-result-popup" position="right" overlay-class="exam-result-popup-overlay">
        <div class="nav">
            <van-icon name="arrow-left" @click="handleCloseExamResultPopup" />
            <div class="nav-name">答题报告</div>
        </div>
        <el-scrollbar class="exam-result-popup-scroll">
            <div class="examname">{{ examinfo.examname }}</div>
            <van-circle v-model="examResult.rightrate" :rate="examResult.rightrate" layer-color="#EEEEEE" color="#FF9950" :stroke-width="80" :size="140" :text="examResult.rightrate + '%'"/>
            <div class="data-box">
                <div class="data-item">
                    <div class="icon-label">
                        <img class="icon" :src="require('@/common/images/mSpecialTopic/finalrightcount_icon.png')"/>
                        <div class="label">正确题数</div>
                    </div>
                    <div class="value">
                        <span class="is-correct">{{ examResult.finalrightcount }}</span>道
                    </div>
                </div>
                <div class="data-item">
                    <div class="icon-label">
                        <img class="icon" :src="require('@/common/images/mSpecialTopic/finalfailcount_icon.png')"/>
                        <div class="label">错误题数</div>
                    </div>
                    <div class="value">
                        <span class="is-error">{{ examResult.finalfailcount }}</span>道
                    </div>
                </div>
                <div class="data-item">
                    <div class="icon-label">
                        <img class="icon" :src="require('@/common/images/mSpecialTopic/totalcount_icon.png')"/>
                        <div class="label">试题总数</div>
                    </div>
                    <div class="value">
                        <span>{{ examResult.totalcount }}</span>道
                    </div>
                </div>
                <div class="data-item">
                    <div class="icon-label">
                        <img class="icon" :src="require('@/common/images/mSpecialTopic/rightrate_icon.png')"/>
                        <div class="label">正 确 率</div>
                    </div>
                    <div class="value">
                        <span>{{ examResult.rightrate }}</span>%
                    </div>
                </div>
            </div>
            <div class="btn-box">
                <div class="check-analysis" @click="handleCheckAnalysis">查看解析</div>
                <div class="again-exam" @click="handleAgainExam">重新做题</div>
            </div>
        </el-scrollbar>
    </van-popup>
    <div class="loading" v-show="loading">
        <van-loading vertical type="spinner" color="#1989fa"><span style="font-size: 0.24rem">加载中...</span>
        </van-loading>
    </div>
</div>
</template>

<script>
import {getQuestionListV2, updateTopicUserExamDayTrainStartExam, getTopicUserExamErrorQuestionList, getTopicUserExamFavoriteQuestionList, getTopicUserExamSpecialAnswerSheet, saveTopicUserExamQuestionFavorite, saveTopicUserExamQuestionError} from '@/api/specialTopic.js'
import {getAnswerSheetInfo, updateUserexamInfo, getReadOverDetail, updateStartExam} from '@/api/questionbank.js'
import {uploadPauseExam} from '@/api/api.js'
import { mapActions, mapGetters } from 'vuex'
import AnswerArea from './examComponent/answerArea.vue'
export default {
    data() {
        return {
            examinit: false,
            navname: '',
            examinfo: {},
            page: 1,
            questioninfo: [],
            questionContentLoading: false,
            answerSheetData: {
                allcount: 0,
                answerdisplaytype: 0,
                answerkeysinfo: [],
                questionindex: 1,
                isshow: 0,
                usecount: 0
            },
            answerSheetConentLoading: false,
            pageinfo: {
                pageCount: 1,
                pageNum: 1,
                pageSize: 1,
                rowCount: 0
            },
            fontSize: 32,
            examTime: '00:00:00',
            pause: false,
            countDownTimer: null,
            examsurtimesseconds: 0,
            localexamtime: 0,
            pattern: 1,
            examResultVisible: false,
            examResult: {},
            seeWrongQuestionsData: false,
            againExamLoading: false,
            mrylCode: '',
            answerSetShow: false,
            submitAutoJump: false,
            answerSheetShow: false,
            saveProgressSuccessShow: false,
            exitTipsShow: false,
            examResultShow: false,
            examResult: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.setClientType(2)
        this.handleGetData()
        // this.handleGetReadOverDetail()
        if (this.$route.params.examsource == 1) {
            if (sessionStorage.getItem('specialTopicMrylCode')) {
                this.mrylCode = sessionStorage.getItem('specialTopicMrylCode')
            }
        }
        if (this.$route.params.examsource == 1) {
            this.navname = '每日一练'
        } else if (this.$route.params.examsource == 2) {
            this.navname = '章节练习'
        } else if (this.$route.params.examsource == 3) {
            this.navname = '历年真题'
        } else if (this.$route.params.examsource == 4) {
            this.navname = '模拟试题'
        } else if (this.$route.params.examsource == 5) {
            this.navname = '我的错题'
        } else if (this.$route.params.examsource == 6) {
            this.navname = '我的收藏'
        } else if (this.$route.query.source && this.$route.query.source === 'lxjl') {
            this.navname = '练习记录'
        }

        if (localStorage.getItem('examSet') && JSON.parse(localStorage.getItem('examSet'))) {
            let examSet = JSON.parse(localStorage.getItem('examSet'))
            if (examSet.fontSize) {
                this.fontSize = examSet.fontSize
            }
            if (examSet.pattern) {
                if (this.$route.params.examsource == 5 || this.$route.params.examsource == 6) {
                    this.pattern = 2
                } else {
                    this.pattern = examSet.pattern
                }
            }
            if (examSet.submitAutoJump) {
                if (this.$route.params.examsource == 5 || this.$route.params.examsource == 6) {
                    this.submitAutoJump = false
                } else {
                    this.submitAutoJump = examSet.submitAutoJump
                }
            }
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    beforeDestory() {
        sessionStorage.setItem('specialTopicMrylCode', '')
        if (this.countDownTimer) {
            clearInterval(this.countDownTimer)
        }
    },
    methods: {
        handleGetData() {
            if (this.$route.query.examid) {
                /*
                    examsource: 做题来源
                        1: 每日一练
                        2：章节练习
                        3：历年真题
                        4：模拟试题
                        5：我的错题
                        6：我的收藏
                */
                if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                    
                    this.handleGetAnswerSheetInfo()
                }
            } else if (this.$route.params.examsource == 5 || this.$route.params.examsource == 6) {
                this.pattern = 2
                if (this.$route.query.catecode && this.$route.query.sectioncode && this.$route.query.subjectcode) {
                    if (this.$route.params.examsource == 5) {
                        this.handleGetTopicUserExamErrorQuestionList()
                    } else {
                        this.handleGetTopicUserExamFavoriteQuestionList()
                    }
                    this.handleGetTopicUserExamSpecialAnswerSheet()
                }
            }
        },
        // 获取试题信息
        handleGetQuestionListV2() {
            this.setLoading(true)
            // if (!this.examinit) {
            //     this.setLoading(true)
            // } else {
            //     this.questionContentLoading = true
            // }
            getQuestionListV2({
                data: {
                    examid: this.$route.query.examid,
                    page: this.page,
                    status: this.seeWrongQuestionsData ? 0 : ''
                },
                success: data => {
                    this.examinit = true
                    data.questioninfo.forEach(item => {
                        if (!item.favcode) {
                            item.favcode = ''
                        }
                        if (data.examstatus === 0) {
                            if (item.issubmit && this.pattern === 2) {
                                item.editable = false
                            } else {
                                item.editable = true
                            }
                        } else{
                            item.editable = false
                        }
                        if (item.questiontype === 2) {
                            if (item.uselanswer) {
                                item.uselanswer = item.uselanswer.split(',')
                            } else {
                                item.uselanswer = []
                            }
                        } else if (item.questiontype === 4) {
                            item.optionslist = [
                                {
                                    optionsvalue: 'T',
                                    optionsshowvalue: 'A',
                                    optionsinfo: '正确'
                                },
                                {
                                    optionsvalue: 'F',
                                    optionsshowvalue: 'B',
                                    optionsinfo: '错误'
                                }
                            ]
                        }
                        if (item.quesanalysis === '') {
                            item.quesanalysis = '暂无解析'
                        }
                        item.olduselanswer = item.uselanswer + ''
                    })
                    if (data.examstatus === 1) {
                        this.page = 1
                    }
                    this.questioninfo = data.questioninfo
                    this.pageinfo = data.pageinfo
                    delete data.questioninfo
                    delete data.pageinfo
                    this.examinfo = data
                    if (this.examinfo.examstatus !== 1 && !this.countDownTimer) {
                        this.examsurtimesseconds = this.examinfo.examsurtimes
                        this.examTime = this.handleSecondsFormat(this.examsurtimesseconds)
                        this.countDownTimer = setInterval(() => {
                            this.localexamtime++
                            if (!this.pause) {
                                this.examsurtimesseconds--
                                this.examTime = this.handleSecondsFormat(this.examsurtimesseconds)
                                if (this.examsurtimesseconds === 0) {
                                    clearInterval(this.countDownTimer)
                                }
                            }
                        }, 1000)
                    }
                    this.setLoading(false)
                    this.questionContentLoading = false
                },
                error: error => {
                    this.setLoading(false)
                    this.questionContentLoading = false
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 我的错题获取试题数据
        handleGetTopicUserExamErrorQuestionList() {
            if (!this.examinit) {
                this.setLoading(true)
            } else {
                this.questionContentLoading = true
            }
            let params = {
                condition: {
                    catecode: this.$route.query.catecode,
                    examcode: this.$route.params.examcode,
                    sectioncode: this.$route.query.sectioncode,
                    subjectcode: this.$route.query.subjectcode,
                },
                page: this.page,
                pagesize: 1
            }
            getTopicUserExamErrorQuestionList({
                data: params,
                success: data => {
                    this.examinit = true
                    this.examinfo = {
                        examname: '我的错题'
                    }
                    data.data.forEach(item => {
                        if (!item.favcode) {
                            item.favcode = ''
                        }
                        if (item.issubmit && item.uselanswer) {
                            item.editable = false
                        } else {
                            item.editable = true
                        }
                        if (item.questiontype === 2) {
                            if (item.uselanswer) {
                                item.uselanswer = item.uselanswer.split(',')
                            } else {
                                item.uselanswer = []
                            }
                        } else if (item.questiontype === 4) {
                            item.optionslist = [
                                {
                                    optionsvalue: 'T',
                                    optionsshowvalue: 'A',
                                    optionsinfo: '正确'
                                },
                                {
                                    optionsvalue: 'F',
                                    optionsshowvalue: 'B',
                                    optionsinfo: '错误'
                                }
                            ]
                        }
                        if (item.quesanalysis === '') {
                            item.quesanalysis = '暂无解析'
                        }
                    })
                    this.questioninfo = data.data
                    this.pageinfo = data.pageableData
                    this.setLoading(false)
                    this.questionContentLoading = false
                },
                error: error => {
                    this.setLoading(false)
                    this.questionContentLoading = false
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleGetTopicUserExamFavoriteQuestionList() {
            if (!this.examinit) {
                this.setLoading(true)
            } else {
                this.questionContentLoading = true
            }
            let params = {
                condition: {
                    catecode: this.$route.query.catecode,
                    examcode: this.$route.params.examcode,
                    sectioncode: this.$route.query.sectioncode,
                    subjectcode: this.$route.query.subjectcode,
                },
                page: this.page,
                pagesize: 0
            }
            getTopicUserExamFavoriteQuestionList({
                data: params,
                success: data => {
                    this.examinit = true
                    this.examinfo = {
                        examname: '我的收藏'
                    }
                    data.data.forEach(item => {
                        item.isfavorite = 1
                        item.favcode = item.keycode
                        if (item.issubmit && item.uselanswer) {
                            item.editable = false
                        } else {
                            item.editable = true
                        }
                        if (item.questiontype === 2) {
                            if (item.uselanswer) {
                                item.uselanswer = item.uselanswer.split(',')
                            } else {
                                item.uselanswer = []
                            }
                        } else if (item.questiontype === 4) {
                            item.optionslist = [
                                {
                                    optionsvalue: 'T',
                                    optionsshowvalue: 'A',
                                    optionsinfo: '正确'
                                },
                                {
                                    optionsvalue: 'F',
                                    optionsshowvalue: 'B',
                                    optionsinfo: '错误'
                                }
                            ]
                        }
                        if (item.quesanalysis === '') {
                            item.quesanalysis = '暂无解析'
                        }
                    })
                    this.questioninfo = data.data
                    this.pageinfo = {
                        pageCount: 1,
                        pageNum: 1,
                        pageSize: 0,
                        rowCount: data.data.length
                    }
                    this.setLoading(false)
                    this.questionContentLoading = false
                },
                error: error => {
                    this.setLoading(false)
                    this.questionContentLoading = false
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleSecondsFormat(s) {  //将考试时间秒转成 时:分：秒
            let hour = this.handleZeroCompensation(Math.floor(s/3600), 2),
            minute = this.handleZeroCompensation(Math.floor((s - hour * 3600) / 60), 2),
            second = this.handleZeroCompensation(s - hour * 3600 - minute * 60, 2)
            return hour + ":" + minute + ":" + second
        },
        handleZeroCompensation(num, length) { // 补零
            return (Array(length).join('0') + num).slice(-length)
        },
        // 获取答题卡
        handleGetAnswerSheetInfo() {
            this.setLoading(true)
            getAnswerSheetInfo({
                data: {exampid: this.$route.query.examid},
                success: data => {
                    this.setLoading(false)
                    this.answerSheetData = data.data
                    if (this.$route.query.ischeck) {
                        this.page = 1
                    } else {
                        this.page = this.answerSheetData.questionindex
                    }
                    this.handleGetQuestionListV2()
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 我的收藏/我的错题 获取答题卡
        handleGetTopicUserExamSpecialAnswerSheet() {
            this.setLoading(true)
            getTopicUserExamSpecialAnswerSheet({
                data: {
                    catecode: this.$route.query.catecode,
                    datasource: this.$route.params.examsource == 5 ? 2 : 1,
                    examcode: this.$route.params.examcode,
                    sectioncode: this.$route.query.sectioncode,
                    subjectcode : this.$route.query.subjectcode
                },
                success: data => {
                    this.setLoading(false)
                    this.answerSheetData = data.data
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleReturnDetails() {
            if (this.examinfo.examstatus === 0 && (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4)) {
                this.exitTipsShow = true
            } else {
                this.handleExit()
            }
        },
        handleSaveExit() {
            this.questioninfo.forEach((item, index) => {
                if ((item.uselanswer + '') !== (item.olduselanswer + '')) {
                    this.$refs.answerArea.handleSaveExamQuestionItem(item)
                }
                if (index === this.questioninfo.length - 1) {
                    this.handleUploadPauseExam(true)
                }
            })
        },
        handleExit() {
            let subjectcode = this.$route.query.subjectcode
            let section = ''
            if (this.$route.query.source && this.$route.query.source === 'lxjl') {
                section = 'lxjl'
            } else if (this.$route.params.examsource == 1) {
                section = 'mryl'
            } else if (this.$route.params.examsource == 2) {
                section = 'zjlx'
            } else if (this.$route.params.examsource == 3) {
                section = 'lnzt'
            } else if (this.$route.params.examsource == 4) {
                section = 'mnst'
            } else if (this.$route.params.examsource == 5) {
                section = 'wdct'
            } else if (this.$route.params.examsource == 6) {
                section = 'wdsc'
            }
            // this.$router.go(-1)
            window.location.replace(location.origin + '/m/specialTopic/' + this.$route.params.examcode + '/topic?subjectcode=' + subjectcode + '&section=' + section)
        },
        handleJumpPage(item) {
            if (item.questionindex > this.pageinfo.rowCount || this.page === item.questionindex) {
                return
            }
            if (this.examinfo.examstatus === 0 && this.pattern === 1) {
                this.questioninfo.forEach(item => {
                    if ((item.uselanswer + '') !== (item.olduselanswer + '')) {
                        this.$refs.answerArea.handleSaveExamQuestionItem(item)
                    }
                })
            }
            this.page = item.questionindex
            if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                this.handleGetQuestionListV2()
            } else if (this.$route.params.examsource == 5) {
                this.handleGetTopicUserExamErrorQuestionList()
            } else if (this.$route.params.examsource == 6) {
                this.handleGetTopicUserExamFavoriteQuestionList()
            }
            this.answerSheetShow = false
        },
        handleChangePage(direction) {
            if (this.examinfo.examstatus === 0 && this.pattern === 1) {
                this.questioninfo.forEach(item => {
                    if ((item.uselanswer + '') !== (item.olduselanswer + '')) {
                        this.$refs.answerArea.handleSaveExamQuestionItem(item)
                    }
                })
            }
            if (direction === 'previous') {
                if (this.page > 1) {
                    this.page--
                    if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                        this.handleGetQuestionListV2()
                    } else if (this.$route.params.examsource == 5) {
                        this.handleGetTopicUserExamErrorQuestionList()
                    } else if (this.$route.params.examsource == 6) {
                        // this.handleGetTopicUserExamFavoriteQuestionList()
                    }
                }
            } else if (direction === 'next') {
                if (this.page < this.pageinfo.rowCount) {
                    this.page++
                    if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                        this.handleGetQuestionListV2()
                    } else if (this.$route.params.examsource == 5) {
                        this.handleGetTopicUserExamErrorQuestionList()
                    } else if (this.$route.params.examsource == 6) {
                        // this.handleGetTopicUserExamFavoriteQuestionList()
                    }
                }
            }
        },
        handleChangeFontSize(size) {
            if (this.fontSize !== size) {
                this.fontSize = size
                localStorage.setItem('examSet', JSON.stringify({
                    fontSize: this.fontSize,
                    pattern: this.pattern,
                    submitAutoJump: this.submitAutoJump
                }))
            }
        },
        handleSubmitAutoJumpChange() {
            if (this.submitAutoJump) {
                this.handleChangePattern(1)
            }
            localStorage.setItem('examSet', JSON.stringify({
                fontSize: this.fontSize,
                pattern: this.pattern,
                submitAutoJump: this.submitAutoJump
            }))
        },
        handleChangePattern(pattern) {
            this.pattern = pattern
            localStorage.setItem('examSet', JSON.stringify({
                fontSize: this.fontSize,
                pattern: this.pattern,
                submitAutoJump: this.submitAutoJump
            }))
            if (pattern === 2) {
                this.submitAutoJump = false
            }
            this.questioninfo.forEach(item => {
                item.editable = true
                if (this.pattern === 2 && item.uselanswer && item.issubmit) {
                    item.editable = false
                }
            })
        },
        handleSaveExamQuestionSuccess(data) {
            let usecount = 0
            this.answerSheetData.answerkeysinfo.forEach(item => {
                if (item.innerid === data.innerid) {
                    item.status = data.status
                    item.answerstatus = data.answerstatus
                    item.issubmit = data.issubmit
                }
                if (item.issubmit) {
                    usecount++
                }
            })
            this.answerSheetData.usecount = usecount
        },
        // 自动跳转到下一题
        handleNextPage() {
            if (this.page < this.pageinfo.rowCount) {
                this.page++
                if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                    this.handleGetQuestionListV2()
                } else if (this.$route.params.examsource == 5) {
                    this.handleGetTopicUserExamErrorQuestionList()
                } else if (this.$route.params.examsource == 6) {
                    this.handleGetTopicUserExamFavoriteQuestionList()
                }
            }
        },
        // 错题移除成功
        handleRemoveErrorsSuccess() {
            if (this.pageinfo.rowCount > this.page) {
                this.handleGetTopicUserExamErrorQuestionList()
                this.handleGetTopicUserExamSpecialAnswerSheet()
            } else {
                if (this.page > 1) {
                    this.page--
                }
                this.handleGetTopicUserExamErrorQuestionList()
                this.handleGetTopicUserExamSpecialAnswerSheet()
            }
        },
        // 收藏源 取消收藏成功
        handleCancelFavoriteSuccess() {
            if (this.pageinfo.rowCount > this.page) {
                this.handleGetTopicUserExamFavoriteQuestionList()
                this.handleGetTopicUserExamSpecialAnswerSheet()
            } else {
                if (this.page > 1) {
                    this.page--
                }
                this.handleGetTopicUserExamFavoriteQuestionList()
                this.handleGetTopicUserExamSpecialAnswerSheet()
            }
        },
        // 保存进度
        handleSaveProgress() {
            this.questioninfo.forEach((item, index) => {
                if (item.uselanswer.length) {
                    if ((item.uselanswer + '') !== (item.olduselanswer + '')) {
                        this.$refs.answerArea.handleSaveExamQuestionItem(item)
                    }
                    if (index === this.questioninfo.length - 1) {
                        this.handleUploadPauseExam()
                    }
                } else {
                    if (index === this.questioninfo.length - 1) {
                        this.handleUploadPauseExam()
                    }
                }
            })
        },
        handleUploadPauseExam(exit) {
            this.setLoading(true)
            uploadPauseExam({
                data: {userexamid: this.$route.query.examid, localexamtime: this.localexamtime},
                success: data => {
                    this.setLoading(false)
                    if (this.countDownTimer) {
                        clearInterval(this.countDownTimer)
                    }
                    if (exit) {
                        this.handleExit()
                    } else {
                        this.saveProgressSuccessShow = true
                        this.answerSheetShow = false
                    }
                },
                error: error => {
                    this.setLoading(false)
                }
            })
        },
        handleOpenSubmitDialog() {
            this.$refs.submitDialog.handleOpen()
        },
        // 提交做题
        handleSubmitExam() {
            if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                this.questioninfo.forEach((item, index) => {
                    if (item.uselanswer.length) {
                        if ((item.uselanswer + '') !== (item.olduselanswer + '')) {
                            this.$refs.answerArea.handleSaveExamQuestionItem(item)
                        }
                        this.$nextTick(() => {
                            if (index === this.questioninfo.length - 1) {
                                this.handleUpdateUserexamInfo()
                                this.answerSheetShow = false
                                this.examResultShow = true
                            }
                        })
                    } else {
                        this.$nextTick(() => {
                            if (index === this.questioninfo.length - 1) {
                                this.handleUpdateUserexamInfo()
                                this.answerSheetShow = false
                                this.examResultShow = true
                            }
                        })
                    }
                })
            }
        },
        handleUpdateUserexamInfo() {
            let params = {
                exampid: this.$route.query.examid,
                anmode: this.pattern
            }
            this.setLoading(true)
            updateUserexamInfo({
                data: params,
                success: data => {
                    this.examinfo.examstatus = 1
                    this.handleGetReadOverDetail()
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleGetReadOverDetail() {
            getReadOverDetail({
                data: {exampid: this.$route.query.examid},
                success: data => {
                    this.setLoading(false)
                    this.examResultShow = true
                    data.data.rightrate = Number(data.data.rightrate)
                    this.examResult = data.data
                    if (this.examinfo.isastrict) {
                        this.examsurtimesseconds = this.examResult.factexamtime * 60
                        this.examTime = this.handleSecondsFormat(this.examsurtimesseconds)
                    }
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleSeeWrongQuestionsDataChange() {
            this.page = 1
            this.handleGetQuestionListV2()
        },
        handlePauseExam() {
            this.pause = true
            this.$refs.clickContinuePopu.startClickContinue()
        },
        examinationTimeCalculation() {
            this.pause = false
        },
        handleCloseExamResultPopup() {
            this.examResult = {}
            this.examResultShow = false
            this.handleExit()
        },
        // 查看解析
        handleCheckAnalysis() {
            this.examResultShow = false
            this.page = 1
            this.handleGetData()
        },
        // 重新考试
        handleAgainExam() {
            if (this.$route.params.examsource == 1) {
                this.againExamLoading = true
                updateTopicUserExamDayTrainStartExam({
                    data: {
                        code: this.mrylCode,
                        examcode: this.$route.params.examcode,
                        subjectcode: this.examResult.subjectcode,
                        traindate: ''
                    },
                    success: data => {
                        location.replace(location.origin + location.pathname + '?examid=' + data.data + '&subjectcode=' + this.examResult.subjectcode)
                        this.againExamLoading = false
                    },
                    error: error => {
                        this.againExamLoading = false
                        this.$toast.fail(error.msg)
                    }
                })
            } else if (this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                updateStartExam({
                    data: {
                        topiccode: this.$route.params.examcode,
                        subjectcode: this.examResult.subjectcode,
                        sectioncode: this.examResult.sectioncode,
                        assetinnerid: this.examResult.assetinnerid,
                        taskid: this.examResult.taskid,
                        examid: ''
                    },
                    success: data => {
                        location.replace(location.origin + location.pathname + '?examid=' + data.data + '&subjectcode=' + this.examResult.subjectcode)
                        this.againExamLoading = false
                    },
                    error: error => {
                        this.againExamLoading = false
                        this.$toast.fail(error.msg)
                    }
                })
            }
        },
        // 取消错题
        handleSaveTopicUserExamQuestionError(item) {
            let params = {
                opcode: item.keycode,
                optype: 2
            }
            saveTopicUserExamQuestionError({
                data: params,
                success: data => {
                    // this.$message.success('操作成功！')
                    this.handleRemoveErrorsSuccess()
                },
                error: error => {
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 收藏/取消收藏
        handleSaveTopicUserExamQuestionFavorite(item) {
            saveTopicUserExamQuestionFavorite({
                data: {
                    opcode: item.isfavorite ? item.favcode : item.innerid,
                    optype: item.isfavorite ? 2 : 1
                },
                success: data => {
                    item.favcode = data.data
                    if (item.isfavorite) {
                        // this.$message.success('操作成功！')
                        item.isfavorite = 0
                    } else {
                        // this.$message.success('收藏成功！')
                        item.isfavorite = 1
                    }
                    // if (this.$route.params.examsource == 6) {
                    //     this.handleCancelFavoriteSuccess()
                    // }
                },
                error: error => {
                    this.$toast.fail(error.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setClientType'
        ])
    },
    computed: {
        ...mapGetters(
            ['user', 'domainlist','domainInfo', 'loading', 'loginPop']
        )
    },
    watch: {
        'user': {
            handler(newV, oldV) {
                if (!oldV.loginToken && newV.loginToken) {
                    this.handleGetData()
                }
            },
            deep: true
        }
    },
    components: {
        AnswerArea
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-exam {
    width: 100vw;
    height: 100vh;
    .nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .exam-content {
        height: calc(100vh - 0.88rem);
        padding-top: 0.1rem;
        box-sizing: border-box;
        background: #F8F8F8;
        .examname-count {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.28rem 0.32rem;
            box-sizing: border-box;
            background: #fff;
            margin-bottom: 0.2rem;
            .examname {
                width: 4.74rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 0.32rem;
                color: #333333;
                line-height: 0.45rem;
            }
            .count {
                font-size: 0.32rem;
                color: #999999;
                span {
                    color: #1D60AD;
                }
            }
        }
        .answer-area-scroll {
            height: calc(100% - 1.21rem - 1rem);
            .empty-box {
                text-align: center;
                .icon {
                    width: 2.68rem;
                    height: 2.2rem;
                    display: inline;
                    margin: 0.2rem 0;
                }
                .text {
                    font-size: 0.24rem;
                    color: #999999;
                    line-height: 0.2rem;
                }
            }
        }
        .bottom-handle {
            height: 1rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .handle-page {
                width: 0.78rem;
                text-align: center;
                line-height: 1rem;
                font-size: 0.4rem;
                color: #333333;
                &.disabled {
                    color: #999999;
                }
            }
            .handle-item {
                width: 1.48rem;
                height: 1rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .handle-icon {
                    width: 0.38rem;
                    height: 0.38rem;
                }
                .el-icon-star-on, .el-icon-star-off, .el-icon-setting {
                    font-size: 0.38rem;
                }
                .el-icon-star-off, .el-icon-setting {
                    color: #666666;
                }
                .el-icon-star-on {
                    color: #FFC550;
                }
                .label {
                    font-size: 0.22rem;
                    color: #666666;
                    line-height: 0.3rem;
                    margin-top: 0.04rem;
                }
            }
        }
    }
    .van-overlay {
        background: rgba(0,0,0,.7) !important;
    }
    .answer-sheet-popup {
        padding: 0.08rem 0 0;
        border-radius: 0.5rem 0.5rem 0 0;
        box-sizing: border-box;
        height: 70vh;
        .title {
            padding: 0.32rem 0 0.12rem;
            text-align: center;
            font-size: 0.32rem;
            color: #333333;
            line-height: 0.45rem;
        }
        .legend-box {
            padding: 0 0.28rem;
            box-sizing: border-box;
            .pattern {
                display: flex;
                align-items: center;
                margin-bottom: 0.28rem;
                .item {
                    display: flex;
                    align-items: center;
                    margin-right: 0.28rem;
                    .label {
                        font-size: 0.24rem;
                        color: #333333;
                        line-height: 0.34rem;
                        margin-right: 0.04rem;
                    }
                    .square {
                        width: 0.24rem;
                        height: 0.24rem;
                        background: #E5E5E5;
                        border: 0.01rem solid #CFCFCF;
                        box-sizing: border-box;
                        border-radius: 0.02rem;
                        &.not-done {
                            background: #fff;
                        }
                        &.correct {
                            background: #40D06B;
                            border: 0.01rem solid #40D06B;
                        }
                        &.error {
                            background: #FF6666;
                            border: 0.01rem solid #FF6666;
                        }
                    }
                }
            }
        }
        .question-item-box {
            padding: 0 0.32rem;
            display: flex;
            flex-wrap: wrap;
            .question-item {
                width: 0.8rem;
                height: 0.8rem;
                border: 0.01rem solid #CFCFCF;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 0.3rem;
                font-size: 0.32rem;
                color: #333333;
                &:not(:nth-of-type(6n)) {
                    margin-right: 0.4rem;
                }
                &.issubmit {
                    background: #E5E5E5;
                    border: none;
                }
                &.correct {
                    background: #0ABF53;
                    color: #fff;
                    border: none;
                }
                &.error {
                    background: #F56C6C;
                    color: #fff !important;
                    border: none;
                }
            }
        }
        .btn-box {
            height: 1rem;
            display: flex;
            align-items: center;
            .submit-exam {
                width: 50%;
                line-height: 1rem;
                text-align: center;
                font-size: 0.3rem;
                color: #fff;
                background: linear-gradient( 270deg, #4A80ED 0%, #59B7FF 100%);
            }
            .save-progress {
                width: 50%;
                line-height: 1rem;
                text-align: center;
                font-size: 0.3rem;
                color: #1D60AD;
                background: #DCEDFF;
            }
        }
    }
    .answer-set-popup {
        padding: 0.08rem 0.28rem 0;
        border-radius: 0.5rem 0.5rem 0 0;
        box-sizing: border-box;
        .handle-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.32rem 0;
            &:not(:last-of-type) {
                border-bottom: 0.01rem solid #E5E5E5;
            }
            .icon-label {
                display: flex;
                .icon {
                    width: 0.38rem;
                    height: 0.38rem;
                    margin-right: 0.2rem;
                }
                .label {
                    font-size: 0.28rem;
                    color: #333333;
                    line-height: 0.4rem;
                }
                .tips {
                    font-size: 0.2rem;
                    color: #999999;
                    line-height: 0.28rem;
                    margin-top: 0.02rem;
                }
            }
            &.font-size-set {
                .handle-box {
                    width: 3.84rem;
                    height: 0.62rem;
                    background: #EEEEEE;
                    border-radius: 0.1rem;
                    padding: 0.04rem 0;
                    box-sizing: border-box;
                    display: flex;
                    .item {
                        width: 0.96rem;
                        text-align: center;
                        line-height: 0.54rem;
                        color: #409EFF;
                        font-size: 0.28rem;
                        &.active {
                            background: #409EFF;
                            color: #fff;
                            border-radius: 0.1rem;
                        }
                    }
                }
            }
            .handle-box {
                .el-radio {
                    .el-radio__input {
                        height: 0.48rem;
                        .el-radio__inner {
                            width: 0.48rem;
                            height: 0.48rem;
                            &::after {
                                width: 0.2rem;
                                height: 0.2rem;
                            }
                        }
                        .el-radio__original {
                            height: 0.48rem;
                        }
                    }
                    .el-radio__label {
                        display: none;
                    }
                }
            }
        }
    }
    .save-progress-success-popup, .exit-tips-popup {
        width: 6.86rem;
        height: 6.3rem;
        background: #fff;
        border-radius: 0.2rem;
        padding: 0.4rem 0.48rem 0;
        box-sizing: border-box;
        .bg1 {
            position: absolute;
            top: 0;
            right: 0;
            width: 1.44rem;
            height: 1.1rem;
            z-index: 10;
        }
        .bg2 {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 2.58rem;
            height: 0.88rem;
            z-index: 10;
        }
        .el-icon-close {
            position: absolute;
            top: 0.24rem;
            right: 0.24rem;
            font-size: 0.4rem;
            color: #999999;
            font-weight: bold;
            z-index: 11;
        }
        .success-icon {
            width: 2.8rem;
            height: 2.8rem;
            margin: 0 auto 0.18rem;
        }
        .exit-icon {
            width: 1.6rem;
            height: 1.6rem;
            margin: 0.4rem auto 0.4rem;
        }
        .text {
            font-size: 0.38rem;
            color: #333333;
            line-height: 0.53rem;
            text-align: center;
            margin-bottom: 0.24rem;
        }
        .btn {
            height: 0.88rem;
            background: linear-gradient( 360deg, #4A80ED 0%, #59B7FF 100%);
            border-radius: 0.1rem;
            text-align: center;
            line-height: 0.88rem;
            color: #fff;
            font-size: 0.32rem;
            position: relative;
            z-index: 12;
        }
        .btn-box {
            display: flex;
            justify-content: space-between;
            margin-top: 0.8rem;
            position: relative;
            z-index: 12;
            .btn-item {
                width: 2.85rem;
                height: 0.88rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.1rem;
                font-size: 0.32rem;
                box-sizing: border-box;
                &.cancel {
                    background: #DAEBFF;
                    border: 0.01rem solid #409EFF;
                    color: #409EFF;
                }
                &.exit {
                    background: linear-gradient( 360deg, #4A80ED 0%, #59B7FF 100%);
                    color: #fff;
                }
            }
        }
    }
    .exam-result-popup-overlay {
        background: #fff !important;
    }
    .exam-result-popup {
        width: 100vw;
        height: 100vh;
        background: #F8F8F8;
        .nav {
            background: #fff;
            height: 0.88rem;
            padding: 0 0.32rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            position: relative;
            z-index: 10;
            box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
            .van-icon {
                font-size: 0.4rem;
                position: relative;
                z-index: 12;
            }
            .nav-name {
                position: absolute;
                z-index: 11;
                width: 100%;
                left: 0;
                line-height: 0.88rem;
                text-align: center;
                font-size: 0.34rem;
                color: #333333;
                font-weight: bold;
                box-sizing: border-box;
            }
        }
        .exam-result-popup-scroll {
            height: calc(100vh - 0.88rem);
            .el-scrollbar__view {
                padding: 0.8rem 0.6rem;
                .examname {
                    font-size: 0.32rem;
                    line-height: 0.45rem;
                    font-weight: bold;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    margin-bottom: 0.6rem;
                }
                .van-circle {
                    margin: 0 auto 0.8rem;
                    display: block;
                    .van-circle__text {
                        font-size: 0.4rem;
                        color: #333333;
                    }
                }
                .data-box {
                    margin-bottom: 0.8rem;
                    .data-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 0.32rem;
                        .icon-label {
                            display: flex;
                            align-items: center;
                            margin-right: 0.5rem;
                            width: 1.85rem;
                            .icon {
                                width: 0.48rem;
                                height: 0.48rem;
                                margin-right: 0.25rem;
                            }
                            .label {
                                font-size: 0.28rem;
                                color: #333333;
                                line-height: 0.4rem;
                            }
                        }
                        .value {
                            width: 1.3rem;
                            text-align: right;
                            font-size: 0.28rem;
                            color: #333333;
                            span {
                                margin-right: 0.08rem;
                                &.is-correct {
                                    color: #40D06B;
                                }
                                &.is-error {
                                    color: #FF4747;
                                }
                            }
                        }
                    }
                }
                .btn-box {
                    .check-analysis {
                        width: 100%;
                        height: 0.75rem;
                        background: #409EFF;
                        color: #fff;
                        border-radius: 0.38rem;
                        line-height: 0.75rem;
                        margin-bottom: 0.3rem;
                        text-align: center;
                        font-size: 0.3rem;
                    }
                    .again-exam {
                        width: 100%;
                        height: 0.75rem;
                        background: #DAEBFF;
                        color: #409EFF;
                        border: 0.01rem solid #409EFF;
                        border-radius: 0.38rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.3rem;
                    }
                }
            }
        }
    }
    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .2);
        z-index: 10000;
    }
}
</style>